/* ------------------------------------------------------------------------------
@name: Products
@description: Products
--------------------------------------------------------------------------------- */

const Products = (() => {
  // - handleProductsSearch
  const handleProductsSearch = () => {
    const $searchInput = $(".products-down__input input");

    // - event listener
    $searchInput.on("input", (e) => {
      const searchValue = $(e.currentTarget).val().toLowerCase();
      $(".products__item").each((_, item) => {
        const productName = $(item)
          .find(".products__item__caption")
          .text()
          .toLowerCase();

        $(item).toggle(productName.indexOf(searchValue) !== -1);
      });
    });
  };

  // - init
  const init = () => {
    handleProductsSearch();
  };

  return {
    init,
  };
})();

export default Products;
